import * as React from 'react'

function PhoneIcon(props) {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 512 512'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <title>{'Search'}</title>
      <circle cx={11} cy={11} r={7} stroke='currentColor' strokeWidth={2} />
      <path
        stroke='currentColor'
        strokeWidth={2}
        strokeLinecap='round'
        d='M0 32L144 0l80 144-83.8 67c36.1 68.4 92.3 124.6 160.8 160.8L368 288l144 80L480 512H448C200.6 512 0 311.4 0 64L0 32z'
      />
    </svg>
  )
}

export default PhoneIcon
